import { useMemo, useState } from "react";
import { trendingItems } from "@/mocks/gossip";

const FILTERS = [
  { key: "all", label: "全部热瓜" },
  { key: "verify", label: "已实锤" },
  { key: "hot", label: "发酵中" },
  { key: "filed", label: "待实锤" },
  { key: "reverse", label: "反转" },
];

const TAG_STYLE: Record<string, string> = {
  verify: "bg-secondary-100 text-secondary-700",
  hot: "bg-primary-100 text-primary-700",
  filed: "bg-accent-100 text-accent-700",
  reverse: "bg-background-200 text-foreground-700",
};

export default function HotList() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () =>
      active === "all" ? trendingItems : trendingItems.filter((i) => i.tagType === active),
    [active]
  );

  return (
    <section id="hot" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span> 今日热瓜榜
            </p>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
              海外吃瓜 · 正在发酵的翻车现场
            </h2>
            <p className="mt-3 text-sm text-foreground-600 max-w-2xl">
              聚合海外网红黑料最新动态，按证据状态打标。榜单每 30 分钟根据讨论热度与事件进展自动刷新。
            </p>
          </div>
          <div className="inline-flex items-center gap-1 rounded-full bg-background-100 p-1 self-start md:self-auto overflow-x-auto max-w-full">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                type="button"
                onClick={() => setActive(f.key)}
                className={`px-3.5 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  active === f.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-700"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-2">
          {list.map((item, rankIdx) => (
            <article
              key={item.id}
              className="group flex gap-4 rounded-2xl bg-background-100/70 border border-background-200 p-4 md:p-5 hover:border-primary-300 transition-colors"
            >
              <div className="flex flex-col items-center gap-1 shrink-0">
                <span
                  className={`font-latin text-2xl md:text-3xl leading-none ${
                    rankIdx === 0 ? "text-primary-600" : "text-foreground-400"
                  }`}
                >
                  {String(rankIdx + 1).padStart(2, "0")}
                </span>
                <span className="h-px w-6 bg-background-300"></span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium ${TAG_STYLE[item.tagType]}`}
                  >
                    {item.tag}
                  </span>
                  <span className="text-[11px] text-foreground-500">{item.field}</span>
                  <span className="text-[11px] text-foreground-400 ml-auto flex items-center gap-1">
                    <i className="ri-time-line"></i>{item.time}
                  </span>
                </div>
                <a href="#scene" className="block mt-2.5 font-heading font-bold text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {item.title}
                </a>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs">
                  <span className="inline-flex items-center gap-1.5 text-foreground-500">
                    <i className="ri-user-3-line"></i>{item.person}
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-accent-700 font-medium">
                    <i className="ri-fire-fill"></i>{item.heatText}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 text-center">
          <button
            type="button"
            className="inline-flex items-center gap-2 rounded-full bg-background-100 border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            加载更多热瓜 <i className="ri-arrow-down-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}